import React from 'react';

var Messages = function Messages(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.43 6.5l4.818 4.72c.418.41 1.086.41 1.504 0l4.819-4.72H6.429zM19 7.9l-4.848 4.749a3.075 3.075 0 0 1-4.304 0L5 7.899v8.526c0 .594.481 1.075 1.075 1.075h11.85c.594 0 1.075-.481 1.075-1.075V7.9zM6.075 4.5h11.85A3.075 3.075 0 0 1 21 7.575v8.85a3.075 3.075 0 0 1-3.075 3.075H6.075A3.075 3.075 0 0 1 3 16.425v-8.85A3.075 3.075 0 0 1 6.075 4.5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Messages.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Messages as icon };
export default iconHandler(Messages);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Messages.js
// module id = 611
// module chunks = 0